export { DIALOG_SIZE as WIZARD_SIZE } from "../Dialog";
export var WIZARD_TABS_BACKGROUND_VIEW;
(function (WIZARD_TABS_BACKGROUND_VIEW) {
    WIZARD_TABS_BACKGROUND_VIEW["normal"] = "normal";
    WIZARD_TABS_BACKGROUND_VIEW["transparent"] = "transparent";
})(WIZARD_TABS_BACKGROUND_VIEW || (WIZARD_TABS_BACKGROUND_VIEW = {}));
//# sourceMappingURL=types.js.map